/**
 * @fileoverview The i18next namespace the account-apps-ui bundles register under.
 * @package @puffin-core/account-apps-ui
 *
 * A ZERO-IMPORT leaf module, deliberately: `useAccountAppsUiTranslate()` is imported by every component in this
 * package, and routing the constant through `strings/index.js` would drag `en.js` and `es.js` into every one of those
 * import chains for one short string.
 *
 * APP-ENTITLEMENT-001 Phase 9 (2026-10-14) — namespace #43, born on the mechanism.
 *
 * @module @puffin-core/account-apps-ui/strings/namespace
 */

/** The canonical namespace under which account-apps-ui strings live in i18next. */
export const ACCOUNT_APPS_UI_NAMESPACE = 'accountAppsUi';
